import { trans } from '@spotahome/soyuz/client';

import Modal from '../../Modal';
import ModalHeader from '../../ModalHeader';
import ModalBody from '../../ModalBody';
import VerificationIconWrapper from '../../VerificationIconWrapper';
import HouseLabelCircledIcon from '../../icons/HouseLabelCircledIcon';

import './VerificationModal.scss';

const LANDLORD_LIST_ITEMS_KEYS = [
  'listing.verification-modal.ll.2-1',
  'listing.verification-modal.ll.2-2',
  'listing.verification-modal.ll.2-3',
  'listing.verification-modal.ll.2-4',
  'listing.verification-modal.ll.2-5'
];

const PROPERTY_LIST_ITEMS_KEYS = [
  'listing.verification-modal.property.2-1',
  'listing.verification-modal.property.2-2'
];

const VerificationModal = ({ checkedIcon = null, handleClose, isOpen }) => {
  return (
    <Modal
      isOpen={isOpen}
      size="medium"
      contentLabel="modal"
      ariaHideApp={false}
      onRequestClose={handleClose}
      className="verification-modal"
    >
      <ModalHeader
        label={trans('listing.verification_modal.title')}
        onRequestClose={handleClose}
        className="verification-modal__header"
      />
      <ModalBody>
        {checkedIcon && (
          <div>
            <div className="verification-modal__subtitle">
              {checkedIcon}
              <span>{trans('listing.verification_modal.property-title')}</span>
            </div>
            <div className="verification-modal__text">
              <div>{trans('listing.verification-modal.property.1')}</div>
              <ul>
                {PROPERTY_LIST_ITEMS_KEYS.map((key, i) => (
                  <li key={`property-${i}`}>{trans(key)}</li>
                ))}
              </ul>
              <div>{trans('listing.verification-modal.property.3')}</div>
            </div>
          </div>
        )}
        <div>
          <div className="verification-modal__subtitle">
            <VerificationIconWrapper>
              <HouseLabelCircledIcon />
            </VerificationIconWrapper>
            <span>{trans('listing.verification_modal.ll-title')}</span>
          </div>
          <div>
            <div>{trans('listing.verification-modal.ll.1')}</div>
            <ul>
              {LANDLORD_LIST_ITEMS_KEYS.map((item, i) => (
                <li key={`ll-${i}`}>{trans(item)}</li>
              ))}
            </ul>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VerificationModal;
